<template>
  <div class="wrapperdtsy">

        <Module ref="Module"
        :title="''"
        :desc="''"
        :moreTitle="'定投计算器算收益'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :loadStyle="'height: 315px'"
        :checkData="checkData"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">

            <div v-for="(pageData, index) in slotProps.list" v-bind:key="index">
  <div class="top-wrapper" @click="knowDTAction" >
    <div class="top-tip-text">按照每月1号定投进行计算。</div>
    <div class="top-tip-textleft">了解定投
      <img src="@/assets/right-arrow-gray.png"
         alt=""
         class="right-arrow"/>
    </div>
  </div>
  <div class="single top">
    <span class="period">周期</span>
    <span class="syl-min">普通定投</span>
    <span class="syl">慧定投</span>
    <span class="syl-min">目标止盈</span>
    <span class="syl-r">移动止盈</span>
  </div>
  <div class="single bottom">
    <span class="period">近1年</span>
    <span :class="['syl-min', `${upDown(pageData.PTDT_Y)}`]"
    >{{`${getCurValue(pageData.PTDT_Y)}`}}</span>
    <span :class="['syl', `${upDown(pageData.DWDT_Y)}`]"
    >{{`${getCurValue(pageData.DWDT_Y)}`}}</span>
    <span :class="['syl-min', `${upDown(pageData.MBDT_Y)}`]"
    >{{`${getCurValue(pageData.MBDT_Y)}`}}</span>
    <span :class="['syl-r', `${upDown(pageData.YDDT_Y)}`]"
    >{{`${getCurValue(pageData.YDDT_Y)}`}}</span>
  </div>
  <div class="single bottom">
    <span class="period">近2年</span>
    <span :class="['syl-min', `${upDown(pageData.PTDT_TWY)}`]"
    >{{`${getCurValue(pageData.PTDT_TWY)}`}}</span>
    <span :class="['syl', `${upDown(pageData.DWDT_TWY)}`]"
    >{{`${getCurValue(pageData.DWDT_TWY)}`}}</span>
    <span :class="['syl-min', `${upDown(pageData.MBDT_TWY)}`]"
    >{{`${getCurValue(pageData.MBDT_TWY)}`}}</span>
    <span :class="['syl-r', `${upDown(pageData.YDDT_TWY)}`]"
    >{{`${getCurValue(pageData.YDDT_TWY)}`}}</span>
  </div>
  <div class="single bottom">
    <span class="period">近3年</span>
    <span :class="['syl-min', `${upDown(pageData.PTDT_TRY)}`]"
    >{{`${getCurValue(pageData.PTDT_TRY)}`}}</span>
    <span :class="['syl', `${upDown(pageData.DWDT_TRY)}`]"
    >{{`${getCurValue(pageData.DWDT_TRY)}`}}</span>
    <span :class="['syl-min', `${upDown(pageData.MBDT_TRY)}`]"
    >{{`${getCurValue(pageData.MBDT_TRY)}`}}</span>
    <span :class="['syl-r', `${upDown(pageData.YDDT_TRY)}`]"
    >{{`${getCurValue(pageData.YDDT_TRY)}`}}</span>
  </div>
  <div class="single bottom">
    <span class="period">近5年</span>
    <span :class="['syl', `${upDown(pageData.PTDT_FY)}`]"
    >{{`${getCurValue(pageData.PTDT_FY)}`}}</span>
    <span :class="['syl', `${upDown(pageData.DWDT_FY)}`]"
    >{{`${getCurValue(pageData.DWDT_FY)}`}}</span>
    <span :class="['syl', `${upDown(pageData.MBDT_FY)}`]"
    >{{`${getCurValue(pageData.MBDT_FY)}`}}</span>
    <span :class="['syl-r', `${upDown(pageData.YDDT_FY)}`]"
    >{{`${getCurValue(pageData.YDDT_FY)}`}}</span>
  </div>
            </div>

          </div>
        </Module>
  </div>
</template>

<style lang="less" scoped>
.wrapperdtsy {
  background-color: white;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 12px;
}
.single {

  font-family: DINAlternate-Bold;
  display: flex;
  font-size: 30px;
  align-items: center;
  justify-content: space-between;
  height: 90px;
}
.gray {
  color: #999999;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.top {
  color: #999999;
  font-size: 28px;
    font-family: PingFangSC-Regular;
  .period {
    font-family: PingFangSC-Regular;
    text-align: left;
    width: 15%;
  }
  .syl {
    text-align: center;
    width: 22%;
  }
  .syl-min {
    text-align: center;
    width: 21%;
  }
  .syl-r {
    text-align: right;
    width: 21%;
  }
  .avg {
    text-align: center;
    width: 26%;
  }
  .rank {
    text-align: right;
    width: 24%;
  }
}
.bottom {
  font-size: 32px;
  .period {
    font-size: 30px;
    font-family: PingFangSC-Regular;
    text-align: left;
    width: 15%;
    padding-top: 1px;
  }
  .syl {
    text-align: center;
    width: 22%;
  }
  .syl-min {
    text-align: center;
    width: 21%;
  }
  .syl-r {
    text-align: right;
    width: 21%;
  }
  .avg {
    text-align: center;
    width: 26%;
  }
  .rank {
    text-align: right;
    width: 24%;
  }
  .rank-wrap {
    padding: 10px 0px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 30px;
    .rank {
      color: black;
    }
    .sc {
      color: #666666;
    }
  }
}
.more-wrapper {
  background-color: #ffffff;
  padding: 30px;
}

.more-text {
  font-size: 30px;
  color: #008aff;
  text-align: center;
  line-height: 30px;
}
.top-wrapper {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 90px;
  padding-left: 24px;
  padding-right: 14px;
  background: #F5F5F5;
  border-radius: 8px;
}
.top-tip-text {
  font-size: 30px;
  color: #666666;
}
.top-tip-textleft {
  font-size: 30px;
  color: #666666;
  display: flex;
  align-items: center;
}
.right-arrow {
    width: 32px;
    height: 32px;
  }
</style>

<script>
import Module from '@/components/Module.vue';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'mark-period-increase',
  components: {
    Module,
  },
  props: {},
  watch: {},
  data() {
    return {
      fundCode: '',
      fundType: '',
      bfundType: '',
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.render();
  },
  methods: {
    mainQueryError() {
      this.$refs.Module.showMainError();
    },
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      this.$refs.Module.start();
    },
    fetchCache() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (!fundinfo) {
        return [];
      }
      return [fundinfo];
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        reject();
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    getCurValue(value) {
      if (value === '--') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
    knowDTAction() {
      // 了解定投
      const zdLink = { LinkType: '2', LinkTo: 'fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=定投是什么？' };
      detailPushPage({
        type: zdLink.LinkType,
        url: zdLink.LinkTo,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: 'd211f561b9854076a8d9db96d6a0b065',
        url: '/pages/targetCalculateEntrance',
        params: {
          FCODE: this.fundCode,
          SHORTNAME: name,
        },
      });
      this.reportMonitor({
        eventName: 'pz.middle.dtsy.more',
      });
    },
  },
};
</script>
